<template>
  <Layout>
    <PageHeader
      :items="items"
    />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">{{ title }}</span>
        <span>
          <button
            size="sm"
            class="p-0 ml-2 btn-link-add"
            @click.prevent="openCreateUpdateModal(null, null, 'create')"
          >
            Crear
            <b-icon
              class="icon-plus"
              icon="plus-circle-fill"
            ></b-icon>
          </button>
        </span>
      </div>
      <div class="card-app">
        <b-row>
          <b-col class="m-0 p-0">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template #head(actions)>
                <span class="title-actions d-flex justify-content-center">Acciones</span>
                <div class="d-flex content-actions">
                  <span>Información</span>
                  <span>Editar</span>
                  <span>Eliminar</span>
                </div>
              </template>
              <template v-slot:cell(group_info__description)="row">
                {{ row.item.group_info ? row.item.group_info.description : '' }}
              </template>
              <template v-slot:cell(user_set)="row">
                {{ row.value.length }}
              </template>
              <template v-slot:cell(permissions)="row">
                {{ row.value.length }}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs" class="d-flex">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    :disabled="
                      isSubmitting || actionsLoadings[`info-btn-${row.index}`]
                    "
                    @click="
                      openDetailModal(
                        row.item,
                        row.index,
                        `info-btn-${row.index}`
                      )
                    "
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fe-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    @click="
                      openCreateUpdateModal(row.item, row.index, 'update')
                    "
                  >
                    <b-icon-pencil></b-icon-pencil>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <b-icon-trash></b-icon-trash>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- Detail modal -->
    <b-modal
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
    >
      <!-- <pre>{{ detailModal.content }}</pre> -->
      <table class="table-hover table-sm mb-0">
        <tr>
          <th style="text-align: right">Nombre</th>
          <td>{{ _.capitalize(detailModal.content.name) }}</td>
        </tr>
        <tr>
          <th style="text-align: right">Descripción</th>
          <td>{{
            detailModal.content.group_info
              ? detailModal.content.group_info.description
              : ''
          }}</td>
        </tr>
        <tr>
          <th style="text-align: right">Permisos</th>
          <td v-if="detailModal.content.permissions_info">
            <ul>
              <li
                v-for="(permission, index) in detailModal.content
                  .permissions_info"
                :key="index"
              >
                {{ permission.name }}
              </li>
            </ul> </td
          ><td v-else>Sin permisos asignados</td>
        </tr>
        <tr>
          <th style="text-align: right">Miembros</th>
          <td v-if="detailModal.content.users_set_info">
            <ul>
              <li
                v-for="(user, index) in detailModal.content.users_set_info"
                :key="index"
              >
                {{
                  user.first_name
                    ? `${user.first_name} ${user.last_name} (${user.username})`
                    : user.username
                }}
              </li>
            </ul> </td
          ><td v-else>Sin miembros</td>
        </tr>
      </table>
    </b-modal>
    <!-- Create-Update modal -->
    <b-modal
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' ? 'sm' : 'lg'"
    >
      <GroupsCreateForm
        v-if="action === 'create'"
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm"
      >
      </GroupsCreateForm>
      <GroupsUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :form="updateForm"
      >
      </GroupsUpdateForm>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary"
          pill
          size="sm"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          {{ $t('cancel') }}
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          pill
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : $v.updateForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t('submit') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Eliminar grupo"
      ok-title="Delete"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteGroup"
    >
      <p>
        ¿Está seguro de borrar el grupo llamado
        <b>{{ toDelete ? toDelete.name : '' }}</b> ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-primary" pill @click="cancel">
          {{ $t('cancel') }}
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          pill
          :disabled="isSubmitting"
          @click="ok"
        >
          <span v-if="!isSubmitting">
            {{ $t('delete') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { groupsMethods } from '@state/helpers'
import { required, minLength } from 'vuelidate/lib/validators'
import GroupsCreateForm from '@views/roles_management/groups/create-form'
import GroupsUpdateForm from '@views/roles_management/groups/update-form'

export default {
  page: {
    title: 'Grupos',
    meta: [
      { name: 'Administración de Grupos', content: 'Administración de Grupos' },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    GroupsCreateForm,
    GroupsUpdateForm,
  },
  data() {
    return {
      title: 'Grupos',
      items: [
        { text: '/', path: '/home', to: { name: 'home' } },
        {
          text: 'Grupos',
          active: true,
        },
      ],
      extraButtons: [
        {
          variant: 'info',
          title: 'Crear nuevo grupo',
          label: 'Agregar',
          to: { name: 'form' },
          function: true,
          icon: 'plus-circle-fill',
        },
      ],
      tableHeaders: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true,
        },
        {
          key: 'group_info__description',
          label: 'Descripción',
          sortable: true,
        },
        {
          key: 'user_set',
          label: 'Usuarios',
        },
        {
          key: 'permissions',
          label: 'Permisos',
        },
        {
          key: 'actions',
          label: 'Acciones',
        },
      ],
      action: '',
      createForm: {
        name: '',
        description: '',
        user_set: [],
        permissions: [],
      },
      updateForm: {
        name: '',
        description: '',
        user_set: [],
        permissions: [],
      },
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      toDelete: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      actionsLoadings: {},
    }
  },
  validations: {
    createForm: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    updateForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      user_set: {},
      permissions: {},
    },
  },
  methods: {
    ...groupsMethods,

    myProvider(ctx) {
      const promise = this.fetchGroups(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          return []
        })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Grupo: ${item.name}`
      const promise = context.fetchGroupsDetail(item.url)
      return promise
        .then((data) => {
          context.detailModal.content = data
          context.detailModalShow = !context.detailModalShow
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      if (action === 'create') {
        this.createForm.name = ''
        this.createForm.description = ''
        this.createForm.user_set = []
        this.updateForm.permissions = []
        this.$v.createForm.$reset()
      } else {
        this.updateForm.name = ''
        this.updateForm.description = ''
        this.updateForm.user_set = []
        this.updateForm.permissions = []
        this.$v.updateForm.$reset()
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create') {
        this.action = 'create'
        this.createUpdateModal.title = `Nuevo Grupo`
      } else {
        this.action = 'update'
        this.updateForm.url = item.url
        this.updateForm.name = item.name
        this.updateForm.description = item.group_info
          ? item.group_info.description
          : ''
        this.updateForm.user_set = item.user_set
        this.updateForm.permissions = item.permissions
        this.createUpdateModal.title = `Actualizar Grupo`
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    onFormSubmit(evt) {
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.createForm.$anyError) {
        context.$v.createForm.$touch()
      }
      let form =
        context.action === 'create' ? context.createForm : context.updateForm
      const promise = context.createUpdateGroups(form)
      return promise
        .then((data) => {
          if (form.url) {
            context.$generate_toast(
              context,
              'success',
              'Grupo actualizado exitosamente'
            )
          } else {
            context.$generate_toast(
              context,
              'success',
              'Grupo creado exitosamente'
            )
          }
          context.createUpdateModalShow = !context.createUpdateModalShow
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
    openDeleteModal(item, index) {
      let context = this
      context.toDelete = item
      context.deleteModalShow = !context.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },
    deleteGroup() {
      let context = this
      context.isSubmitting = true
      const promise = context.deleteGroups(context.toDelete.url)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            'Group eliminado exitosamente'
          )
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
  },
}
</script>
